export default theme => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  idTableCell: {
    display: 'flex',
    alignItems: 'center'
  },
  deadlinesInvalid: {
    backgroundColor: theme.palette.common.muted,
  },
  previewStopTable: {
    border: `1px solid ${theme.palette.border}`,
  },
  lastTableCell: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  warnIcon: {
    color: theme.palette.warning.main,
  },
  dangerIcon: {
    color: theme.palette.danger.main
  },
  neutralIcon: {
    color: theme.palette.common.muted,
  }
});

